import { SvrConn } from "../utils/axios/index";

/**
 * Verificar Configuración General
 */
const getParamsEmpresa = async () => {
  let res = {};
  try {
    res = await SvrConn.get("/api/params/getparamsempresa");
  } catch (Error) {
    res = Error;
  }
  return res;
};
export { getParamsEmpresa };
